import { z } from "zod"
import { CreateInvoiceDtoSchema, InvoiceSourceType } from "@mimber/schema"

/**
 * Form schema for CreateInvoiceForm
 * Derives from the shared CreateInvoiceDtoSchema
 */
export const createInvoiceFormSchema = CreateInvoiceDtoSchema.pick({
  sourceType: true,
  membershipId: true,
  dueAt: true,
}).extend({
  sourceType: z.nativeEnum(InvoiceSourceType).default(InvoiceSourceType.CUSTOM),
  membershipId: z
    .string()
    .uuid("Invalid member")
    .optional()
    .or(z.literal(""))
    .transform((val) => (val === "" ? undefined : val)),
  dueAt: z
    .union([
      z.literal(""),
      z.string().datetime({ message: "Due date must be a valid date" }),
    ])
    .optional()
    .transform((val) => (!val ? undefined : val)),
  lineItemName: z.string().min(1, "Item name is required").max(255),
  lineItemQuantity: z
    .number()
    .int()
    .min(1, "Quantity must be at least 1")
    .default(1),
  lineItemUnitAmount: z.number().min(0, "Amount must be non-negative"),
})

export type CreateInvoiceFormData = Omit<
  z.infer<typeof createInvoiceFormSchema>,
  "lineItems"
> & {
  lineItemName: string
  lineItemQuantity: number
  lineItemUnitAmount: number
}
